import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import _ from 'lodash';

import Placeholder from '../../Placeholder';

import {
  Wrapper,
  DrawerBackground,
  Close,
  Menu,
  ButtonSection,
  Stylist,
  Config,
  MenuList,
  MenuItem,
  Button,
} from './DrawerMenu.style';

import { reducer } from '../../../redux/sagas/aws-cognito-redux-saga';

import { getCurrentDiagnosisUser } from '../../../redux/selectors/hairDiagnosis';
import { resetCurrentDiagnosisUser } from '../../../redux/actions/hairDiagnosis';
import { fetchUser, clearCurrentUser } from '../../../redux/actions/user';
import { lsGetItem } from '../../../utils';
import { CUSTOMER, STYLIST_SALONID } from '../../../pages/SalonConsultationPage/localStorageKeys';

class DrawerMenu extends React.Component {
  handleLogout = () => {
    const { history, locale, signOut, clearCurrentUser, resetCurrentDiagnosisUser, closeMenu } = this.props;
    signOut();
    clearCurrentUser();
    resetCurrentDiagnosisUser();
    closeMenu();
    history.push(`/${locale}/salon-consultation/login`);
  };

  handleMenuClick = url => () => {
    const {  history, locale, closeMenu } = this.props;
    closeMenu();
    if (RegExp('/salon-consultation/customer/top').test(url)) {
      const salonId = lsGetItem(STYLIST_SALONID) || false;
      const customer = JSON.parse(lsGetItem(CUSTOMER)) || false;
      if (salonId && Object.keys(customer).length > 0) {
        history.push(`/${locale}${url}`);
      } else if (!RegExp('/salon-consultation/customer/search').test(history.location.pathname)) {
        history.push(`/${locale}/salon-consultation/customer/search`);
      }
    } else {
      history.push(`/${locale}${url}`);
    }
  };

  render() {
    const { isOpen, locale, copy, closeMenu, stylist } = this.props;
    return (
      <React.Fragment>
        <DrawerBackground onClick={closeMenu} className={isOpen ? 'is-active' : ''} />
        <Wrapper className={isOpen ? 'is-active' : ''}>
          <Menu>
            <Close onClick={closeMenu} />
            <MenuList>
              {_.get(copy, 'menu') && copy.menu.map(menu => (
                <MenuItem key={`${menu.label.trim()}`}>
                  {!menu.external ? (
                    <span onClick={this.handleMenuClick(menu.url)}>
                      {menu.label}
                    </span>
                  ) : (
                    <a href={menu.url} target="_blank">{menu.label}</a>
                  )}
                </MenuItem>
              )) ||
              (
                <React.Fragment>
                  <MenuItem>
                    <Placeholder w="100%" h="24px" pb="20px" />
                  </MenuItem>
                  <MenuItem>
                    <Placeholder w="100%" h="24px" pb="20px" />
                  </MenuItem>
                  <MenuItem>
                    <Placeholder w="100%" h="24px" pb="20px" />
                  </MenuItem>
                </React.Fragment>
              )}
            </MenuList>
          </Menu>
          <ButtonSection>
            <Stylist>
              <div className="salon-name">{stylist.given_name ? (
                <span>{stylist.salon}</span>
              ) : (
                <Placeholder w="160px" h="24px" />
              )
              }</div>
              <div className="name">{stylist.given_name ? (
                <span>{stylist.given_name} {stylist.family_name}</span>
              ) : (
                <Placeholder w="160px" h="24px" />
              )
              }</div>
              <Button onClick={this.handleLogout}>
                {copy.siteCopy ? copy.siteCopy.globalMenu.logOutCtaLabel : <Placeholder w="160px" h="24px" />}
              </Button>
            </Stylist>
            <Config>
              <Link to={`/${locale}/salon-consultation/setting`} href={`/${locale}/salon-consultation/setting`} className="button" onClick={closeMenu}>
                {copy.siteCopy ? copy.siteCopy.globalMenu.settingCtaLabel : <Placeholder w="160px" h="24px" />}
              </Link>
            </Config>
          </ButtonSection>
        </Wrapper>
      </React.Fragment>
    );
  }
}

DrawerMenu.defaultProps = {
  isOpen: false,
  copy: {},
};

DrawerMenu.propTypes = {
  isOpen: PropTypes.bool,
  locale: PropTypes.string.isRequired,
  location: PropTypes.shape().isRequired,
  copy: PropTypes.shape(),
  closeMenu: PropTypes.func.isRequired,
  signOut: PropTypes.func.isRequired,
  clearCurrentUser: PropTypes.func.isRequired,
  resetCurrentDiagnosisUser: PropTypes.func.isRequired,
  fetchUser: PropTypes.func.isRequired,
  auth: PropTypes.shape({}).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
};

const mapState = state => ({
  copy: state.salonConsultaionSiteOptions,
  locale: state.locale,
  currentDiagnosisUser: getCurrentDiagnosisUser(state),
  stylist: state.user,
  auth: state.auth,
});

const mapDispatch = dispatch => ({
  signOut: () => dispatch(reducer.signOut()),
  resetCurrentDiagnosisUser: () => dispatch(resetCurrentDiagnosisUser()),
  fetchUser: username => dispatch(fetchUser(username)),
  clearCurrentUser: () => dispatch(clearCurrentUser()),
});

export default withRouter(connect(mapState, mapDispatch)(DrawerMenu));



// WEBPACK FOOTER //
// ./src/components/SalonConsultation/DrawerMenu/DrawerMenu.js